import { render, staticRenderFns } from "./TreeClassificator.vue?vue&type=template&id=4cf267c0&scoped=true"
import script from "./TreeClassificator.vue?vue&type=script&lang=js"
export * from "./TreeClassificator.vue?vue&type=script&lang=js"
import style0 from "./TreeClassificator.vue?vue&type=style&index=0&id=4cf267c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf267c0",
  null
  
)

export default component.exports